import React from 'react';
import classNames from 'classnames';
import { includes } from 'lodash';
import InlineIcon from '../../../../../ui-components/inline-icon/inline-icon';
import ScheduledIcon from '../../../../../../icons/compiled/components/ScheduledIcon';
import SparkIcon from '../../../../../../icons/compiled/components/SparkIcon';
import TagIcon from '../../../../../../icons/compiled/components/TagIcon';
import TriangleIcon from '../../../../../../icons/compiled/components/TriangleIcon';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import styles from './styles.scss';
export const PLAYABLE_VIDEO_CARD_TYPES = [VIDEO_CARD_TYPES.VIDEO, VIDEO_CARD_TYPES.RECENT_VIDEO, VIDEO_CARD_TYPES.CHANNEL];
const CardThumbnailPlaceholderIcon = _ref => {
  let {
    type,
    thumbnailUrl,
    itemType
  } = _ref;
  if (itemType === ItemType.ItemScheduled) {
    return thumbnailUrl ? null : /*#__PURE__*/React.createElement(InlineIcon, {
      className: styles['icon-scheduled'],
      icon: /*#__PURE__*/React.createElement(ScheduledIcon, null)
    });
  }
  if (includes(PLAYABLE_VIDEO_CARD_TYPES, type)) {
    return /*#__PURE__*/React.createElement(InlineIcon, {
      className: classNames(styles.triangle, {
        [styles['with-url']]: thumbnailUrl
      }),
      icon: /*#__PURE__*/React.createElement(TriangleIcon, null)
    });
  }
  if (thumbnailUrl) {
    return null;
  }
  switch (type) {
    case VIDEO_CARD_TYPES.PRODUCT:
      return /*#__PURE__*/React.createElement(InlineIcon, {
        className: styles.icon,
        icon: /*#__PURE__*/React.createElement(TagIcon, null)
      });
    case VIDEO_CARD_TYPES.CUSTOM:
      return /*#__PURE__*/React.createElement(InlineIcon, {
        className: styles.icon,
        icon: /*#__PURE__*/React.createElement(SparkIcon, null)
      });
    default:
      return null;
  }
};
export default CardThumbnailPlaceholderIcon;
//# sourceMappingURL=thumbnail-placeholder-icon.js.map